// extracted by mini-css-extract-plugin
export default {"wrap":"EnableUserDialog-wrap","cancelButton":"EnableUserDialog-cancelButton","enableButton":"EnableUserDialog-enableButton","userCountText":"EnableUserDialog-userCountText"};